import type { IChannelState } from 'src/types/checkout';

type SetFieldFn = (field: keyof IChannelState, value: any) => void;

export const handleStepTransition = (
  targetStep: number,
  state: IChannelState,
  setField: SetFieldFn,
  loginApiData: any
) => {
  const transitions: Record<number, () => void> = {
    0: () => {
      setField('channelName', '');
      setField('emailProviderType', '');
      setField('telegramBotToken', '');
      setField('microsoftTeamsDetails', { code: '' });
    },
    1: () => {
      const defaultUser = { ...loginApiData, assignedType: 'USER' };
      setField('assignUsers', [defaultUser]);
      setField('emailChannelDtls', { channelName: '', email: '' });
      setField('smsChannelDtls', { accountSid: '', authToken: '', srcNumber: '' });
      setField('googleEmailDetails', { code: '' });
      setField('microsoftEmailDetails', { code: '' });

      if (state.channelType === 'SMS') setField('channelName', '');
      if (state.channelType === 'LINE') {
        setField('lineDetails', {
          lineChannelName: '',
          lineChannelSecret: '',
          lineChannelId: '',
          channelCreated: false,
        });
      }
      if (state.channelType === 'VOICE') {
        setField('voiceCallDetails', {
          assignUsers: [defaultUser],
          assignedType: '',
          didNum: '',
          didType: '',
        });
      }
    },
    2: () => {
      if (state.channelType === 'EMAIL' && state.emailProviderType === 'other_provider') {
        setField('smtpDetails', {
          smtpEnabled: true,
          smtpAddress: '',
          smtpPort: 0,
          smtpLogin: '',
          smtpPassword: '',
          smtpDomain: '',
        });
      }
    },
    4: () => {
      if (state.channelType === 'EMAIL' && state.emailProviderType === 'other_provider') {
        setField('imapDetails', {
          imapEnabled: true,
          imapAddress: '',
          imapPort: 0,
          imapLogin: '',
          imapPassword: '',
          imapEnableSsl: true,
        });
      }
    },
    5: () => {
      const defaultUser = { ...loginApiData, assignedType: 'USER' };
      if (state.channelType === 'EMAIL' && state.emailProviderType === 'other_provider') {
        setField('assignUsers', [defaultUser]);
      }
    },
  };

  transitions[targetStep]?.();
};

export const shouldCreateChannel = (targetStep: number, channelType: string) => {
  if (targetStep !== 3) return false;

  const channelsToCreate = [
    'WHATSAPP',
    'MESSENGER',
    'INSTAGRAM',
    'LIVE_CHAT',
    'TELEGRAM',
    'VOICE',
    'LINE',
    'MICROSOFTTEAMS',
    'SMS',
  ];

  return channelsToCreate.includes(channelType);
};

export const shouldCreateEmailOrSMS = (targetStep: number, state: IChannelState) => {
  if (targetStep === 4) {
    return state.channelType === 'EMAIL' && state.emailProviderType !== 'other_provider';
  }
  if (targetStep === 6) {
    return state.channelType === 'EMAIL' && state.emailProviderType === 'other_provider';
  }
  return false;
};

export const shouldRedirect = (targetStep: number, state: IChannelState) => {
  const redirectConditions = [
    targetStep === 4 &&
      [
        'WHATSAPP',
        'VOICE',
        'LIVE_CHAT',
        'MESSENGER',
        'MICROSOFTTEAMS',
        'INSTAGRAM',
        'TELEGRAM',
        'LINE',
        'SMS',
      ].includes(state.channelType),
    targetStep === 5 &&
      state.channelType === 'EMAIL' &&
      state.emailProviderType !== 'other_provider',
    targetStep === 7 &&
      state.channelType === 'EMAIL' &&
      state.emailProviderType === 'other_provider',
  ];

  return redirectConditions.some(Boolean);
};
